document.addEventListener('DOMContentLoaded', function () {
    const donationInput = document.getElementById('addDonationModel_DonationAmount');
    if (!donationInput) return;

    const giftAidSection = document.getElementById('gift-aid-section');
    const ownMoneyFalse = document.getElementById('ownmoney-false');
    const ownMoneyTrue = document.getElementById('ownmoney-true');
    const giftAidBefore = document.getElementById('gift-aid-before');
    const giftAidAfter = document.getElementById('gift-aid-after');

    const buttons = document.querySelectorAll('.suggested-amounts__button');

    const updateGiftAid = (donationAmount) => {
        if (!giftAidBefore || !giftAidAfter) return;

        if (!isNaN(donationAmount) && donationAmount > 0) {
            const giftAidAmount = donationAmount * 0.25;
            giftAidBefore.textContent = `£${donationAmount.toFixed(2)}`;
            giftAidAfter.textContent = `£${(donationAmount + giftAidAmount).toFixed(2)}`;
        } else {
            giftAidBefore.textContent = '£0.00';
            giftAidAfter.textContent = '£0.00';
        }
    };

    if (ownMoneyFalse && giftAidSection) {
        ownMoneyFalse.addEventListener('change', function () {
            if (ownMoneyFalse.checked) giftAidSection.style.display = 'none';
        });
    }

    if (ownMoneyTrue && giftAidSection) {
        ownMoneyTrue.addEventListener('change', function () {
            if (ownMoneyTrue.checked) giftAidSection.style.display = 'block';
        });
    }

    buttons.forEach(button => {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            const value = parseFloat(button.textContent.replace('£', '').trim());
            if (!isNaN(value)) {
                donationInput.value = value.toFixed(2);
                updateGiftAid(value);
            }
        });
    });

    donationInput.addEventListener('input', function () {
        const donationAmount = parseFloat(donationInput.value);
        updateGiftAid(donationAmount);
    });

    updateGiftAid(parseFloat(donationInput.value));
});